import { Locale, type LocalizedString } from "../Locale.js";

export const referencesPathMap = {
	[Locale.cs]: "pripadove-studie",
	[Locale.en]: "case-studies",
	[Locale.pl]: "case-studies",
	[Locale.sk]: "pripadove-studie",
} satisfies LocalizedString;
